import React from "react";
import {Box, BoxProps} from "@mui/material";
import {useTheme} from "@material-ui/core/styles";

type FlexRowProps = {
  gap?: number;
  alignItems?: BoxProps["alignItems"];
  justifyContent?: BoxProps["justifyContent"];
  fullWidth?: boolean;
  children: React.ReactNode;
} & BoxProps;

const FlexRow: React.FC<FlexRowProps> = ({
  gap = 0,
  alignItems = "center",
  justifyContent = "flex-start",
  fullWidth = false,
  children,
  ...boxProps
}) => {
  const {spacing} = useTheme();
  return (
    <Box
      display="flex"
      alignItems={alignItems}
      justifyContent={justifyContent}
      width={fullWidth ? "100%" : "auto"}
      gap={gap}
      {...boxProps}
    >
      {children}
    </Box>
  );
};

export default FlexRow;
